import React from 'react';

const PulsingBackground = () => {
  return (
    <div className="pulsing-background">
      <div className="pulse-circle"></div>
      <div className="pulse-circle"></div>
      <div className="pulse-circle"></div>
      <div className="pulse-circle"></div>
    </div>
  );
};

export default PulsingBackground;